import React, { useState, useEffect } from "react";
import { Container, Navbar, Button, Nav } from "react-bootstrap";
import { isMobileDevice } from "../Utils";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import "./index.css";
import { useLocation } from "react-router-dom";

export default function HeaderNav() {
  const [navbar, setNavbar] = useState(false);
  const isMobileOrTabletDevice = isMobileDevice();
  const location = useLocation();
  const isMainPage = location.pathname === "/";
  const hiddenPaths = ["/speakerapplication", "/agenda"];
  
  // Check if current time is after July 8, 2025 5PM ET
  const isAfterRegistrationDeadline = () => {
    const now = new Date();
    const deadline = new Date('2025-07-08T17:00:00-04:00'); // July 8, 2025 5PM ET
    // const deadline = new Date('2025-07-08T00:35:00-07:00');
    return now >= deadline;
  };
  
  const showRegisterButton = !hiddenPaths.includes(location.pathname) && !isAfterRegistrationDeadline();
  const [expanded, setExpanded] = useState(false);
  const isAgendaOrSpeakerPage = location.pathname === "/agenda" || location.pathname === "/speakerapplication";


  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
  let prevScrollPos = window.scrollY;

  // Check for hash fragments or query parameters on initial load
  useEffect(() => {
    // Handle URL hash or query parameter on page load
    const handleInitialScroll = () => {
      // First, check if we arrived here via query parameter
      const urlParams = new URLSearchParams(window.location.search);
      const shouldScrollToTickets = urlParams.get('scrollToTickets') === 'true';

      // Or if we have a hash for the register section
      const hasRegisterHash = window.location.hash === '#register-section';

      if (shouldScrollToTickets || hasRegisterHash) {
        // Wait for everything to load properly
        setTimeout(() => {
          // Try to use the global scrollToTickets function if available
          if (typeof window.scrollToTickets === 'function') {
            window.scrollToTickets();
          } else {
            // If not available, try a direct approach with a longer delay
            setTimeout(() => {
              const registerSection = document.getElementById('register-section');
              if (registerSection) {
                registerSection.scrollIntoView({ behavior: 'smooth' });
              }
            }, 2000);
          }
        }, 1000);
      }
    };

    // Run after component mounts
    handleInitialScroll();
  }, []);

  // Handle scroll behavior only for mobile or tablet devices
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const Navbar = document.getElementById("Navbar");

      if (currentScrollPos === 0) {
        Navbar.classList.remove("navbarTransition");
        setNavbar(false);


      } else {
        if (prevScrollPos > currentScrollPos) {
          setNavbar(true); // Scrolling up

          if (isMobileOrTabletDevice && expanded) {
            setExpanded(false);
          }

        } else {
          if (!isMobileOrTabletDevice) {
            setNavbar(true); // Scrolling down on desktop


          } else {
            setNavbar(false);
            Navbar.classList.add("navbarTransition");
            if (expanded) {
              setExpanded(false); // ✅ Collapse mobile navbar on scroll down
            }
          }
        }
      }
      prevScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobileOrTabletDevice, expanded]);

  const handleMenuClick = () => {
    if (window.scrollY > 0) {
      setNavbar(true);
    }
  };

  const handleNavClick = () => {
    setExpanded(false);
  };

  // Function to handle the Register Now button click
  const handleRegisterClick = (e) => {
    e.preventDefault();
    setExpanded(false);

    if (isAgendaOrSpeakerPage) {
      // Open external link in a new tab
      window.open("https://www.ussaic.com/?scrollToTickets=true#register-section", "_blank", "noopener,noreferrer");
      return;
    }
    // First ensure all components are loaded by setting a flag in localStorage
    localStorage.setItem('scrollToTicketsRequested', 'true');

    // Try to use the global function if available
    if (typeof window.scrollToTickets === 'function') {
      window.scrollToTickets();
    } else {
      // Try multiple attempts to find and call the function
      let attemptCount = 0;
      const maxAttempts = 5;

      const attemptScroll = () => {
        if (attemptCount >= maxAttempts) return;

        if (typeof window.scrollToTickets === 'function') {
          window.scrollToTickets();
        } else {
          attemptCount++;
          setTimeout(attemptScroll, 500);
        }
      };

      attemptScroll();

      // Fallback: Direct approach if all else fails
      setTimeout(() => {
        const ticketSection = document.getElementById('register-section');
        if (ticketSection) {
          ticketSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 2500);
    }
  };

  return (
    <>
      <div>
        <Navbar
          id="Navbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          variant="dark"
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
          className={navbar ? "navbar active" : "navbar"}
        >
          <Container className="navbar-container">
            <Navbar.Brand className="d-flex align-items-center">

              <div>
                <a href="/" target="_self" rel="noopener noreferrer">
                  <img
                    src={imgCDNURL + "ussaiclogo.webp"}
                    alt="ussaic logo"
                    height="auto"
                    width="auto"
                    className="main_logo"
                  />
                </a>
              </div>

            </Navbar.Brand>

            {!isMobileOrTabletDevice ? (


              <div className="navbar-desktop-content ms-auto d-flex align-items-center justify-content-center w-50">
                <div className="navbar-agenda-text">
                  <a
                    href={isAgendaOrSpeakerPage ? "/" : "/agenda"}
                    target={isAgendaOrSpeakerPage ? "_self" : "_self"}
                    rel="noopener noreferrer"
                  >
                    {isAgendaOrSpeakerPage ? "Home" : "Agenda"}
                  </a>
                </div>
                {showRegisterButton && (
                  <div className="registerbutton">
                    <Button
                      variant="outline-primary"
                      className="header-button header-register-button"
                      onClick={handleRegisterClick}
                    >
                      Register Now
                    </Button>
                  </div>
                )}
              </div>
            ) : (

              <>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(!expanded)}>
                  <span style={{ color: "white", fontSize: "1.75rem" }}>
                    {expanded ? "✖" : "☰"}
                  </span>
                </Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="me-auto">
                    <Nav.Link
                      as="a"
                      href={isAgendaOrSpeakerPage ? "/" : "/agenda"}
                      target={isAgendaOrSpeakerPage ? "_self" : "_self"}
                      rel="noopener noreferrer"
                      onClick={handleNavClick}
                    >
                      {isAgendaOrSpeakerPage ? "Home" : "Agenda"}
                    </Nav.Link>
                  </Nav>

                  {showRegisterButton && (
                    <div className="registerbuttonmobile d-flex justify-content-center w-100">
                      <Button
                        variant="outline-primary"
                        className="header-button header-register-button"
                        onClick={handleRegisterClick}
                      >
                        Register Now
                      </Button>
                    </div>
                  )}

                  <div className="mobileaccesibility">
                    <UserWayAccessibilityMenu color="white" width={35} height={35} />
                  </div>
                </Navbar.Collapse>
              </>

            )}
            {/* </>
            )} */}


            {!isMobileOrTabletDevice && (
              <div className="desktopaccesibility">
                <UserWayAccessibilityMenu color="white" width={35} height={35} />
              </div>
            )}




          </Container>
        </Navbar>

        {/* {!showRegisterButton && (
          <div className="mobileaccesibilityotherpages">
            <UserWayAccessibilityMenu color="white" width={35} height={35} />
          </div>
        )} */}

      </div>
    </>
  );
}